import React from 'react';
import ErpcigeCard from './erpcigeCard';

/* import { Metadata } from 'next';
export const metadata: Metadata = {
  title: 'ERP CIGE',
  description: 'Sistema ERP CIGE en Sicons Perú: soluciones integrales para la gestión empresarial',
}; */

const data = [
  {
    img: '/images/erpcigeperu.png',
    title: '',
    description1: '',
    description2: '',
    items: [],
    videoUrl: '',
  },

  {
    img: '',
    title: '',
    description1: 'Sicons Perú se encarga en la Implementación y comercialización del ERP CIGE PERÚ, así como en la asesoría y consultoría del sistema.',
    description2: 'CIGE PERÚ, software de gestión empresarial (ERP) diseñado para pequeñas, medianas y grandes empresas, integrando todas las funciones principales de un negocio en un solo sistema: Finanzas, Contabilidad, Ventas, Marketing, Inventarios, Producción y servicio al cliente.',
    items: ['+ De 1,000 Licencias Atendidas', '+ De 100 Clientes Satisfechos'],
    videoUrl: '',
  },

    {
    img: '',
    title: 'Introducción al ERP CIGE PERU',
    description1: '',
    description2: '',
    items: [],
    videoUrl: 'https://www.youtube.com/embed/mLygmNHVcic',
  },

  {
    img: '',
    title: 'Módulo de Ventas del ERP CIGE',
    description1: '',
    description2: '',
    items: [],
    videoUrl: 'https://www.youtube.com/embed/14siJdBBmJg',
  },
  {
    img: '',
    title: 'Proceso de Compras Locales en el ERP CIGE',
    description1: '',
    description2: '',
    items: [],
    videoUrl: 'https://www.youtube.com/embed/JB3PGq2F4uo',
  },
  {
    img: '',
    title: 'Proceso de Importación en el ERP CIGE',
    description1: '',
    description2: '',
    items: [],
    videoUrl: 'https://www.youtube.com/embed/VghkNlTYUTM',
  },
];

const ErpCige: React.FC = () => {
  return (
    <div className="container mx-auto px-4 md:px-8 lg:px-16 my-12 lg:my-24">
      <h1 className="text-3xl md:text-4xl lg:text-5xl font-bold text-center text-blue mb-8">ERP CIGE PERÚ</h1>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-8 md:gap-12 lg:gap-16">
        {data.map((item, index) => (
          <ErpcigeCard
            key={index}
            img={item.img}
            title={item.title}
            description1={item.description1}
            description2={item.description2}
            items={item.items}
            videoUrl={item.videoUrl}
          />
        ))}
      </div>
    </div>
  );
};

export default ErpCige;
